/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrate for exact accuracy — screens vary in pixel density.`)
};

const es_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibra para una precisión exacta — la densidad de píxeles varía entre pantallas.`)
};

const de_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalibriere für exakte Genauigkeit — Bildschirme unterscheiden sich in der Pixeldichte.`)
};

const nl_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalibreer voor exacte nauwkeurigheid — schermen verschillen in pixeldichtheid.`)
};

const fr_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrez pour une précision exacte — la densité de pixels varie selon les écrans.`)
};

const it_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibra per una precisione esatta — gli schermi variano per densità di pixel.`)
};

const pt_br2_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibre para ter precisão exata — telas variam na densidade de pixels.`)
};

const pt_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibre para maior precisão — os ecrãs variam na densidade de pixels.`)
};

const ja_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確な測定のために校正してください — 画面によってピクセル密度が異なります。`)
};

const zh_ruler_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校准以获得精确结果——不同屏幕的像素密度各不相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_hint", locale)
	if (locale === "en") return en_ruler_hint(inputs)
	if (locale === "es") return es_ruler_hint(inputs)
	if (locale === "de") return de_ruler_hint(inputs)
	if (locale === "nl") return nl_ruler_hint(inputs)
	if (locale === "fr") return fr_ruler_hint(inputs)
	if (locale === "it") return it_ruler_hint(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_hint(inputs)
	if (locale === "pt") return pt_ruler_hint(inputs)
	if (locale === "ja") return ja_ruler_hint(inputs)
	return zh_ruler_hint(inputs)
};